import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=25ac6e46&scoped=true"
import script from "./Merchandise.vue?vue&type=script&lang=js"
export * from "./Merchandise.vue?vue&type=script&lang=js"
import style0 from "./Merchandise.vue?vue&type=style&index=0&id=25ac6e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ac6e46",
  null
  
)

export default component.exports